export default function createLocationTagsFromString(value) {
	let splitText = value.toUpperCase().split(' ');

	if (splitText.every(x => x.includes(':'))) {
		let ret = [];
		for (let x of splitText) {
			let range = x.split(':');
			if (range.length === 2) {
			
				ret.push({
					id: x,
					icon: 'map-marker',
					iconType: 'bp',
					label: x,
					type: 'postalRange',
					fromPostalCode: range[0],
					toPostalCode: range[1],
				});
			}
		}
		return ret;
	}
	if (!isNaN(value)) {
		return [{
			id: value,
			icon: 'map-marker',
			iconType: 'bp',
			label: value,
			type: 'postalCodeStartsWith',
			postalCode: value,
		}];
	}

	
	if (splitText.every(x => x.length === 2)) {
		let ret = [];
		for (let x of splitText) {
			ret.push({
				id: x,
				icon: 'globe',
				iconType: 'bp',
				label: x,
				type: 'countryCode',
				countryCode: x,
			});
		}
		return ret;
	}

	return [{
		id: value,
		label: value,
		searchText: value,
		type: 'customText',
	}];
}